import { FC } from "react";

import Image from "next/image";

import { PushBlock as PushBlockUI } from "@jti/ui/components/PushBlock";

import { usePageConfig } from "@/context/PageConfigContext";
import { BUILDER_TEXT_CLASSNAME } from "@/libs/builder/consts";

import { pushBlockInputs } from "./PushBlock.builder";

export type PushBlockBuilderProps = BuilderComponentProps<
  typeof pushBlockInputs
>;

export const PushBlock: FC<PushBlockBuilderProps> = ({
  desktopImage,
  mobileImage,
  alt,
  orientation,
  title,
  subtitle,
  description,
  cta,
  href,
  containedCTA,
  smallHeightOnMobile,
  trackingEvent,
  mobileOrientation,
  logo,
  blockContentProperties,
  secondButton,
}) => {
  const { darkMode } = usePageConfig();

  return (
    <PushBlockUI
      imgDesktop={desktopImage}
      imgMobile={mobileImage}
      alt={alt}
      orientation={orientation}
      mobileOrientation={mobileOrientation}
      title={title}
      subtitle={subtitle}
      // Force the builder text styles in case of HTML migrated from AEM
      text={
        description
          ? `<div class="${BUILDER_TEXT_CLASSNAME}">${description}</div>`
          : ""
      }
      cta={cta}
      smallHeightOnMobile={smallHeightOnMobile}
      trackingEvent={trackingEvent}
      containedCTA={containedCTA}
      href={href}
      renderImage={({ imgDesktop, alt }) => (
        <Image src={imgDesktop} width={840} height={700} alt={alt ?? ""} />
      )}
      logoProps={{
        ...logo,
        link: logo?.link || "",
        title: logo?.title || "",
        alt: logo?.alt || "",
        isDarkMode: darkMode,
      }}
      isBackgroundOverlayEnabled={
        blockContentProperties?.isBackgroundOverlayEnabled
      }
      isFullHeightContent={blockContentProperties?.isFullHeightContent}
      isFullWidthContent={blockContentProperties?.isFullWidthContent}
      blockHeight={blockContentProperties?.blockHeight}
      secondButton={secondButton}
    />
  );
};
